// extracted by mini-css-extract-plugin
export default {"arrowIconRight":"arrowIconRight-Xpyym","container":"container-rhJN1","menu":"menu-x_6ik","button":"button-__WCB","item":"item-anmRx"};